import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { IntegrationsResource } from 'src/client'
import useAccountContext from 'src/contexts/AccountContext'
import logger from 'src/utils/logger'

const useDisconnectFacebookMutation = () => {
  const { handleRefetchUserLocations } = useAccountContext()

  return useMutation(IntegrationsResource.disconnectFacebook, {
    onSuccess: async () => {
      toast.success('Facebook disconnected successfully.')

      try {
        await handleRefetchUserLocations()
      } catch (error) {
        logger.error(
          'There was an error trying to refresh the Business Information.',
          { error }
        )
      }
    },
    onError: (error) => {
      toast.success(
        'There was an error trying to disconnect your Facebook page. Please try again.'
      )
      logger.error('There was an error trying to disconnect to Facebook.', {
        error,
      })
    },
  })
}

export default useDisconnectFacebookMutation
